import { PropsWithChildren } from "react";
import styles from "./styles.module.sass";

export function PopUpLayout({ children }: PropsWithChildren) {
  return <div className={styles.PopUpLayout}>{children}</div>;
}
